import React from 'react';
import { useTranslation } from 'react-i18next';
import { HeadlineSmall } from '@shared/ui/atoms/fonts/Headline';
import { SchengenTrackingSetting } from '@shared/ui/organisms/settings/SchengenTrackingSetting';
import { BuildVersion } from '@shared/ui/organisms/settings/BuildVersion';
import { SectionSaveButton } from './SectionSaveButton';
import { McpIntegrationSetting } from '@shared/ui/organisms/settings/McpIntegrationSetting';
import { LockersSetting } from '@shared/ui/organisms/settings/LockersSetting';
import { SignageSetting } from '@shared/ui/organisms/settings/SignageSetting';
import { IsBetaTester } from '@shared/hooks/IsBetaTester';

interface Props {
  onOpenWaypointScreens: () => void;
}

export function OtherPanel({ onOpenWaypointScreens }: Props) {
  const { t } = useTranslation();
  const isBetaTester = IsBetaTester();
  return (
    <>
      <HeadlineSmall style={{ marginBottom: 16 }}>{t('company-settings-page.other-tab')}</HeadlineSmall>
      <SchengenTrackingSetting />
      <McpIntegrationSetting />
      {isBetaTester && <LockersSetting />}
      <SignageSetting onManageClick={onOpenWaypointScreens} />
      <SectionSaveButton />
      <BuildVersion />
    </>
  );
}
